import { FC, ReactNode } from "react";
import Box from "@mui/material/Box";
import { BRAND_COLORS, SIDEBAR_DIMENSIONS } from "./constants";

interface AppTopbarProps {
  leftContent?: ReactNode;
  rightContent: ReactNode;
}

export const AppTopbar: FC<AppTopbarProps> = ({
  leftContent,
  rightContent,
}) => {
  return (
    <Box
      component="header"
      sx={{
        height: `${SIDEBAR_DIMENSIONS.TOP_BAR_HEIGHT_PX}px`,
        backgroundColor: "#ffffff",
        borderBottom: `1px solid ${BRAND_COLORS.PRUSSIAN}`,
        display: "flex",
        alignItems: "center",
        paddingLeft: "16px",
        paddingRight: "16px",
        flexShrink: 0,
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      {leftContent && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          {leftContent}
        </Box>
      )}
      <Box sx={{ flex: 1, minWidth: 0 }} />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          flexShrink: 0,
        }}
      >
        {rightContent}
      </Box>
    </Box>
  );
};
